
<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-show="false && showCalendar"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import CustomerParam from "@/components/Param/CustomerCompanyParam"

var querystring = require('querystring');
var moment = require('moment');

const PARAM = CustomerParam.getParam();
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportProfileCompany",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Customer Profile' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
      showCalendar: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.PARAM.unshift({
      key: '_index',
      index: true,
    })
    this.PARAM.push({
      key: 'parkinglicense',
      text: 'Parking License No.'
    })
    this.PARAM.push({
      key: 'status',
      text: 'Status'
    })
    this.PARAM = this.PARAM.filter(k => !k.form_section)
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCountry();
  },
  methods: {
    loadCountry() {
      let feedbackItem = 'country data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/country/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCountry = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadState();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadState() {
      let feedbackItem = 'state data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/state/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageState = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadCity();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCity() {
      let feedbackItem = 'city data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/city/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCity = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.showCalendar = true;
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      let feedbackItem = 'car park product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadCustomer();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomer() {
      let feedbackItem = 'customer data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      // if(this.$refs['carparkFilter'].filterValue) {
      //   url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      // }
      url += '/customer/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageCustomer = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicense() {
      let feedbackItem = 'license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/?isCompany=1';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.processReport();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    async processReport() {
      let result = [];

      for(let index in this.pageLicense) {
        let license = this.pageLicense[index];
        let customer = this.pageCustomer.find(k => helper.compareID(k.id, license.customerID))

        if(customer['address1']) {
          let feedbackItem = 'customer address detail'
          this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
          customer['_address'] = await this.$http
            .get(
              helper.SERVER_URL + '/api2/address/' + customer['address1'],
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              if(response.data && response.data.length > 0) {
                this.$refs['pageFeedback'].setFeedbackMessage();
                return helper.parseAddress(response);
              } else {
                this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
              }
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
            })
        }

        if(customer['contact1']) {
          let feedbackItem = 'customer contact detail'
          this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
          customer['_contact'] = await this.$http
            .get(
              helper.SERVER_URL + '/api2/contact/' + customer['contact1'],
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              if(response.data && response.data.length > 0) {
                this.$refs['pageFeedback'].setFeedbackMessage();
                return helper.parseContact(response);
              } else {
                this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
              }
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
            })
        }

        customer['_address'] = customer['_address'] || {}
        customer['_contact'] = customer['_contact'] || {}

        let temp = {};
        for(let key in customer) {
          temp[key] = customer[key];
        }
        for(let key in customer['_address']) {
          temp[key] = customer['_address'][key];
        }
        for(let key in customer['_contact']) {
          temp[key] = customer['_contact'][key];
        }
        
        temp['_personalCorrespondenceAddressCity'] = this.pageCity.find(k => helper.compareID(k.id, temp['personalCorrespondenceAddressCityID'])) || {}
        temp['_personalCorrespondenceAddressState'] = this.pageState.find(k => helper.compareID(k.id, temp['_personalCorrespondenceAddressCity']['stateID'])) || {}
        temp['_personalCorrespondenceAddressCountry'] = this.pageCountry.find(k => helper.compareID(k.id, temp['_personalCorrespondenceAddressState']['countryID'])) || {}
        temp['_personalPermanentAddressCity'] = this.pageCity.find(k => helper.compareID(k.id, temp['personalPermanentAddressCityID'])) || {}
        temp['_personalPermanentAddressState'] = this.pageState.find(k => helper.compareID(k.id, temp['_personalPermanentAddressCity']['stateID'])) || {}
        temp['_personalPermanentAddressCountry'] = this.pageCountry.find(k => helper.compareID(k.id, temp['_personalPermanentAddressState']['countryID'])) || {}
        temp['_companyAddressCity'] = this.pageCity.find(k => helper.compareID(k.id, temp['companyAddressCityID'])) || {}
        temp['_companyAddressState'] = this.pageState.find(k => helper.compareID(k.id, temp['_companyAddressCity']['stateID'])) || {}
        temp['_companyAddressCountry'] = this.pageCountry.find(k => helper.compareID(k.id, temp['_companyAddressState']['countryID'])) || {}

        temp['personalCorrespondenceAddressCityID'] = temp['_personalCorrespondenceAddressCity']['name']
        temp['personalCorrespondenceAddressStateID'] = temp['_personalCorrespondenceAddressState']['name']
        temp['personalCorrespondenceAddressCountryID'] = temp['_personalCorrespondenceAddressCountry']['name']
        temp['personalPermanentAddressCityID'] = temp['_personalPermanentAddressCity']['name']
        temp['personalPermanentAddressStateID'] = temp['_personalPermanentAddressState']['name']
        temp['personalPermanentAddressCountryID'] = temp['_personalPermanentAddressCountry']['name']
        temp['companyAddressCityID'] = temp['_companyAddressCity']['name']
        temp['companyAddressStateID'] = temp['_companyAddressState']['name']
        temp['companyAddressCountryID'] = temp['_companyAddressCountry']['name']

        temp['parkinglicense'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
        temp['status'] = license['status']

        result.push(temp);
      }

      result.sort((a, b) => {
        if(a.name) {
          return String(a.name).localeCompare(b.name)
        }
      })

      this.$refs['pageTable'].setTableData(result);
      this.showExportCSV = true;
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageLicense = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageLicense = null);
      this.loadLicense();
    },

    onFormInput(formData, formParameter, input) {
    },
    onCSVButtonClick() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      var header = [];
      if(carpark) {
        header.push('Car Park Code: ' + carpark.carparkCode)
        header.push('Car Park: ' + carpark.name)
      }
      header.push('Report : Company Profile')
      
      printCSV('#jt-table', `Report Company Profile`, header);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportProfileCompany.vue